import styled from 'styled-components';
import { ButtonType } from '../Button/ButtonStyledComponent';
import { TextBold } from '../../styles/GlobalStyledComponents';
import { colors } from '../../styles/Colors';

interface MainContainerProps {
  $marginBottom: string;
}

export const MainContainer = styled.div<MainContainerProps>`
  width: 100%;
  max-height: 100px;
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
  left: 0px;
  bottom: 0px;
  background-color: #fff;

  @media (max-width: 950px) {
    max-height: 100%;
  }

  @media (max-width: 850px) {
    position: relative;
    max-height: 100%;
    flex-direction: column;
    margin-bottom: ${(props) => `${props.$marginBottom}px`};
    overflow-y: auto;
  }
`;

export const CallMeFooterContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 16px 20px;
  margin-left: 40px;
  flex-grow: 1;
  gap: 8px;

  @media (max-width: 970px) {
  margin-left: 20px;
  }
  @media (max-width: 950px) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 850px) {
    max-width: 300px;
    max-width: 100%;
    gap: 16px;
    margin-left: 0;
  }
`;

export const LegalFooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 8px;
  gap: 16px;
  flex-grow: 2;

  @media (max-width: 950px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 850px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 24px;
  }
`;

export const LegalFooterLink = styled.a`
  font-size: 14px;
  color: ${(props) => props.theme.colors.gray0};
  text-decoration: none;
  line-height: 20px;
  font-weight: 400;
`;

export const CallMeInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const CallMeBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 950px) {
    justify-content: flex-start;
  }
`;

export const CallMeTextInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  line-height: 20px;
`;

export const CallMeBtn = styled(ButtonType)`
  max-width: 200px;
  display: flex;
  gap: 0;
  padding: 0 8px;
`;

export const BtnElements = styled.span`
  width: 100%;
  display: flex;
  gap: 12px;
  padding: 0px 8px;
`;

export const CallMeBtnText = styled(TextBold)`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Phone = styled.a`
  font-size: 16px;
  color: ${colors.green2};
  font-weight: 700;
  line-height: 20px;
  padding-top: 5px;
  width: 100%;
  text-decoration: underline;
  white-space: nowrap;
`;

interface FooterModalProps {
  open?: boolean;
}

export const FooterOverlay = styled.div<FooterModalProps>`
  display: ${(props) => (props.open ? 'block' : 'none')};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
`;

export const MobileFooterImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;

  @media (min-width: 850px) {
    display: none;
  }
`;

export const MobileFooterImage = styled.img`
  max-width: 100%;
  width: 100%;
  height: 100%;
`;

export const FooterImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 46%;
  left: 65%;

  @media (max-width: 650px) {
    left: 60%;
  }

  @media (max-width: 400px) {
    top: 40%;
    left: 53%;
    gap: 0px;
  }
`;

export const FooterImageBanner = styled.img`
  max-width: 180px;
  padding: 8px;
  cursor: pointer;

  @media (max-width: 650px) {
    max-width: 140px;
  }

  @media (max-width: 450px) {
    max-width: 120px;
  }
`;
